<template>
    <div>
        <vs-popup title="" :active.sync="showContactInfoPopup">
            <UserCard :collaborator="selectedCollaborator" :collaboratorAvatar="selectedCollaboratorAvatar" />
        </vs-popup>
			<div class="mt-2">
				<div class="vx-row">
                    <div class="vx-col">
						<h3>Société(s)</h3>
                    </div>
				</div>
				<div class='vx-row' v-for="(society, index) in contractsUsersInfo" :key="index">
					<div class="vx-col mt-2">
						<div>
							<div class="vx-row">
								<div class="vx-col">
                                    <vx-card style="height: 420px;">
                                        <div class="vx-row">
                                            <div class="vx-col p-5 mr-5 black-card">
                                                <div class="vx-row">
                                                    <img :src="societyImages[society.info.societyId] ? societyImages[society.info.societyId] : null" style="width: 264px; height: 150px; background-color: whitesmoke;"/>
                                                </div>
                                                <div class="vx-row center mt-1">
                                                    <h3 style="color: whitesmoke;">{{index}}</h3>
                                                </div>
                                                <div class="vx-row center">
                                                    <vs-divider />
                                                </div>
                                                <div class="vx-row">
                                                    <strong>Contact Commercial :</strong>
                                                </div>
                                                <div class="vx-row" v-for="(collaborator, indexCM) in society.info.commercialContacts" :key="indexCM">
                                                    <div class="vx-col">
                                                        <div class="vx-row" style="width: 68px;">
                                                            <vx-tooltip :text="collaborator.firstname + ' ' + collaborator.lastname">
                                                                <vs-avatar
                                                                    style="border: 1px solid;"
                                                                    class="mx-auto block"
                                                                    size="50px"
                                                                    :src="getCollaboratorAvatar(collaborator.user_id)"
                                                                    @click="displayContactInfoPopup(collaborator)"
                                                                />
                                                            </vx-tooltip>
                                                        </div>

                                                    </div>
                                                    <div class="vx-col">
                                                        <div class="vx-row">
                                                            <strong>{{ collaborator.firstname + " " + collaborator.lastname }}</strong>
                                                        </div>
                                                        <div class="vx-row">
                                                            Tél : {{ collaborator.phone }}
                                                        </div>
                                                        <div class="vx-row">
                                                            <span>Email :&nbsp;</span> <a :href="'mailto:'+collaborator.email">{{ collaborator.email }}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="vx-row">
                                                    <strong>Contact Comptabilité :</strong>
                                                </div>
                                                <div class="vx-row" v-for="(collaborator, indexF) in financialContacts" :key="indexF">
                                                    <div class="vx-col">
                                                        <div class="vx-row" style="width: 68px;">
                                                            <vx-tooltip :text="collaborator.firstname + ' ' + collaborator.lastname">
                                                                <vs-avatar
                                                                    style="border: 1px solid;"
                                                                    class="mx-auto block"
                                                                    size="50px"
                                                                    :src="getCollaboratorAvatar(collaborator.user_id)"
                                                                    @click="displayContactInfoPopup(collaborator)"
                                                                />
                                                            </vx-tooltip>
                                                        </div>

                                                    </div>
                                                    <div class="vx-col">
                                                        <div class="vx-row">
                                                            <strong>{{ collaborator.firstname + " " + collaborator.lastname }}</strong>
                                                        </div>
                                                        <div class="vx-row">
                                                            Tél : {{ collaborator.phone }}
                                                        </div>
                                                        <div class="vx-row">
                                                            <span>Email :&nbsp;</span> <a :href="'mailto:'+collaborator.email">{{ collaborator.email }}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col">
                                                <div class="vx-row mt-2">
                                                    <div class="vx-col mr-2" v-for="(contract, indexC) in society.contracts" :key="indexC">
                                                            <ContractCard :collaborators="contract.data" :contractInfo="getContractInfo(contract.contractId)" @show-collaborator-card="displayContactInfoPopup($event)" @to-keywords="toKeywords($event)" @to-netlink="toNetlink($event)" @to-documents="toDocuments($event)" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </vx-card>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
import store from "@/store/store";
import ContractCard from "@/components/cards/ContractCard";
import UserCard from "@/components/cards/UserCard";

export default {
	name: "SocietyContractsCardsTable",
	components: {
		ContractCard,
		UserCard
	},

	props: {
		contractsUsersInfo: {
			type: Object,
			default: null
		}
	},
	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allContracts: () => {
			return store.state.contracts;
		},
		allSocieties: () => {
			return store.state.societies;
		}
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			societyImages: {},
			financialContacts: [],
			showContactInfoPopup: false,
			selectedCollaborator: null,
			selectedCollaboratorAvatar: null,
		};
	},
	created() {
		this.getAllCollaboratorsAvatar();
		this.getAllContracts();
		this.getAllSocieties();
		this.getFinanceInfo();
		this.getAllSocietiesImages();
	},
	watch: {
		contractsUsersInfo: function(){
			this.getAllSocietiesImages();
		}
	},
	methods: {
		setSelectedSociety(society){
			this.$store.commit("SET_SELECTED_SOCIETY", society);
		},
		toDocuments(societyId){
			let society = this.allSocieties.find(row => row.id == societyId);
			this.setSelectedSociety(society);
			this.$router.push({name: "documents"});
		},
		toKeywords(societyId){
			let society = this.allSocieties.find(row => row.id == societyId);
			this.setSelectedSociety(society);
			this.$router.push({name: "keyword"});
		},
		toNetlink(societyId){
			let society = this.allSocieties.find(row => row.id == societyId);
			this.setSelectedSociety(society);
			this.$router.push({name: "netlink"});
		},
		displayContactInfoPopup(collaborator){
			this.selectedCollaborator = collaborator;
			this.selectedCollaboratorAvatar = this.getCollaboratorAvatar(collaborator.user_id);
			this.showContactInfoPopup = true;
		},
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar ? foundAvatar.avatar : "";
			else return "";
		},
		getAllContracts() {
			this.$store.dispatch("getAllContracts");
		},
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getContractInfo(contractId){
			let returnedContractInfo = {
				id: contractId,
				status: null,
				delivery: null,
				society_id: null
			};
			let foundContract = this.allContracts.find(contract => contract.id == contractId);
			if(foundContract){
				returnedContractInfo.status = foundContract.status.toString();
				returnedContractInfo.delivery = foundContract.delivery.toString();
				returnedContractInfo.society_id = foundContract.society_id.toString();
			}
			return returnedContractInfo;
		},
		getFinanceInfo(){
			this.$http
				.get(this.apiUrl + "contract/getallrankwellfinance")
				.then(resultat => {
					this.financialContacts = resultat.data;
				})
				.catch(err => {
					//console.log(err);
				});
		},
		getSocietyImage(societyId) {
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then(image => {
					this.societyImages[societyId] = image.data;
				})
				.catch(err => {
					//console.log(err);
				});
		},
		getAllSocietiesImages(){
			let queries = [];
			if(this.contractsUsersInfo){
				//console.log(this.contractsUsersInfo);
				let contractsUsersInfoKeys = Object.keys(this.contractsUsersInfo);
				for(let society of contractsUsersInfoKeys){
					//console.log(society);
					queries.push(this.getSocietyImage(this.contractsUsersInfo[society].info.societyId));
				}
				Promise.all(queries)
					.then(results => {
						//console.log(results);
					});
			}
		}
	},
};
</script>

<style lang="scss" scoped>
.black-card {
    color: whitesmoke;
    background-color: #0c293d;
    border-radius: 5px;
}
.center {
  justify-content: center;
}
</style>